import * as React from "react";
import ScrollBar from "react-perfect-scrollbar";
import { selectPackagesByRequiredOfferId } from "../../../balancingSelectors/selectBalancingPackages";
import { ScrollOptions } from "../../../constants/ScrollOptions";
import { IdStyles } from "../../../less/IdStyles";
import { selectGrowthFundIcon } from "../../../selectors/selectShopInfo";
import { IdLoca } from "../../../utils/i18n/IdLoca";
import { ReplacementLoca } from "../../../utils/i18n/ReplacementLoca";
import { utilNumber } from "../../../utils/utilNumber";
import { utilShop } from "../../../utils/utilShop";
import { Icon } from "../../generic/icon/Icon";
import { List } from "../../generic/list/List";
import { TextLoca } from "../../generic/text/TextLoca";
import { OfferLevelRewardPaymentListItem } from "./OfferLevelRewardPaymentListItem";
var renderLevelReward = function (levelReward) {
    return (React.createElement(OfferLevelRewardPaymentListItem, { levelReward: levelReward, key: levelReward.id + "_" + levelReward.resourceReward }));
};
export var OfferLevelRewardPayment = function (_a) {
    var offerCharacteristicId = _a.offerCharacteristicId, locaKeyFlavour = _a.locaKeyFlavour;
    var levelRewards = selectPackagesByRequiredOfferId(offerCharacteristicId);
    var totalRewardAmount = utilShop.getTotalRewardAmount(levelRewards);
    var totalRewardReplacements = new Map([
        [ReplacementLoca.zero_0, utilNumber.format(totalRewardAmount)],
    ]);
    var icon = selectGrowthFundIcon(levelRewards);
    var packageList = (React.createElement(ScrollBar, { component: "div", options: ScrollOptions, className: "offer-body__reward-list" },
        React.createElement(List, { items: levelRewards || [], renderItem: function (item) { return renderLevelReward(item); } })));
    return (React.createElement("div", { className: "offer-body__rewards" },
        React.createElement("div", { className: IdStyles.OfferDetailsHeader + " offer-body__rewards-container offer-body__rewards-container-level" },
            React.createElement(Icon, { icon: icon, styleId: IdStyles.IconMedium }),
            React.createElement("div", { className: "offer-body__rewards-header-text" }, totalRewardAmount > 0 && (React.createElement(TextLoca, { id: IdLoca.xInTotal, replacements: totalRewardReplacements, className: IdStyles.HeadlineOne })))),
        React.createElement("div", { className: IdStyles.OfferRewardListBackground + " offer-body__reward-list-container flex flex--aligned flex--stacked" },
            packageList,
            React.createElement("div", { className: "offer-body__reward-list-header-container" }, locaKeyFlavour && (React.createElement(TextLoca, { id: locaKeyFlavour, className: IdStyles.TextBoldSecondary + " offer-body__reward-list-header" }))))));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/shop/components/OfferLevelRewardPayment.tsx
// module id = 2918
// module chunks = 3